// Angular
import { Injectable } from '@angular/core';
// RxJS
import { Subject } from 'rxjs';
import { MenuConfig } from '../../../../core/_config/menu.config';

@Injectable()
export class MenuConfigService {
	[x: string]: any;
	title: any = '';
	// Public properties
	onConfigUpdated$: Subject<any>;
	// Private properties
	private menuConfig: any;
	aside: any;

	/**
	 * Service Constructor
	 */
	constructor() {
		// register on config changed event and set default config
		this.onConfigUpdated$ = new Subject();
	}

	/**
	 * Returns the menuConfig
	 */
	getMenus() {
		console.log(this.menuConfig,"menuConfigService 29")
		return this.menuConfig;

	}
	// gettitle(menuItem: any): string {
	// 	if (!menuItem || !menuItem.aside) {
	// 		console.error("Menu item or 'aside' property is undefined:", menuItem);
	// 		return ''; // Return default value to prevent errors
	// 	}
	// 	return menuItem.aside.title; // Adjust this based on your data structure
	// }
	gettitle(url) {
		console.log(url,"41")
		if (!this.menuConfig || !this.menuConfig.aside) {
			console.error("Menu item or 'aside' property is undefined:", this.menuConfig);
			// 		return ''; // Return default value to prevent errors
		}else{
		this.menuConfig.aside.items.forEach((element) => {
			console.log(element,"46")
			if (element.submenu) {  //check if the menu item has submenu.
				for (var i = 0; i < element.submenu.length; i++) {
					this.title = this.getPageTitle(element.submenu[i], url);
				}
			} else {
				this.title = this.getPageTitle(element, url);
				console.log(this.title)
			}
			if(((url == '/manager/sparetransfer') || (url == '/manager/sparecart')) && (element.page == '/manager/imprest_spare')) {
				element.selected = true;
			}
			console.log(this.title)
			return this.title;
		});
	}
		
	}

	getPageTitle(element, url) {
		var title;
		console.log(element,"page")
		console.log(url,"url")
		if (element.page == url) { // compare if the page property and the url are equal. If yes, then save the title in local storage
			this.title = element.title;
			element.selected = true;
			localStorage.setItem('menu_title', this.title);
			return title;
		} else {
			element.selected = false;
		}
		console.log("72")
		console.log(localStorage)
	}

	getActiveItem(url) {
		var sidebar = document.getElementsByClassName('sidebar_item');
		if(url == '/manager/sparetransfer' || url == '/manager/sparecart' || url =='manager/newrequest') {
			sidebar[4].classList.add('kt-menu__item--active','kt-menu__item--here');
		}
		var index = this.menuConfig.aside.items.findIndex(item => item.page == '/manager/imprest_spare');
		this.menuConfig.aside.items[index].selected = true;
	}

	/**
	 * Load config
	 *
	 * @param config: any
	 */
	loadConfigs(config: any) {
		this.menuConfig = config;
		this.onConfigUpdated$.next(this.menuConfig);
	}
}
